export var CommunicationType;
(function (CommunicationType) {
    CommunicationType["EMAIL"] = "email";
    CommunicationType["SMS"] = "sms";
    CommunicationType["INBOUND_EMAIL"] = "inbound_email";
})(CommunicationType || (CommunicationType = {}));
//# sourceMappingURL=communication.js.map